import React from "react";
import ButtonPreview from "./ButtonPreview";
import DropdownPreview from "./DropdownPreview";

const ButtonGroupPreview = ({ config, classes }) => {
  return (
    <div className={`d_flex gap_2 h_100 flex_wrap  ${classes}`}>
      {config?.button_list?.map((b) => {
        if (b.type === "button") {
          return <ButtonPreview key={b.id} config={b} classes={b.classes?.join(" ")} />;
        }
        if (b.type === "dropdown") {
          return <DropdownPreview key={b.id} config={b} classes={b.classes?.join(" ")} />;
        }
        return null;
      })}
    </div>
  );
};

export default ButtonGroupPreview;
